import { STHead } from "@/components";
import { STAboutUs } from "@/components/STAboutUs";
import React from "react";

const AboutUs = () => {
  return (
    <>
      <STHead
        title="About Us"
        description="Deeptech startup using advanced biochemistry and chemistry for developing bio-materials for various industries."
        keywords="About Sustanix, mission, green chemistry, sustainable additives"
        canonicalUrl="https://sustanix.com/about-us/"
        ogTitle="Fundamental & Applied research on novel biomaterials"
        ogDescription="We invent and scale novel chemistries & biochemistries in the biomaterials space for various industries"
        ogKeywords="About Sustanix, mission, green chemistry, sustainable additives"
        ogUrl="https://sustanix.com/about-us/"
        ogImage="https://sustanix.com/opengraph-image.webp"
        ogType="website"
      />
      <STAboutUs />
    </>
  );
};

export default AboutUs;
